export default __webpack_public_path__ + "static/media/Snapcraft_icon_130160.87a75161.svg";